import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/product-detail/page";
import CartPage from "../pages/cart/page";
import CheckoutPage from "../pages/checkout/page";
import OrderCompletePage from "../pages/order-complete/page";
import FaqPage from "../pages/faq/page";
import ShippingPage from "../pages/shipping/page";
import ReturnsPage from "../pages/returns/page";
import ContactPage from "../pages/contact/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/order-complete",
    element: <OrderCompletePage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/shipping",
    element: <ShippingPage />,
  },
  {
    path: "/returns",
    element: <ReturnsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
